const UPDATE_USER_PREFERENCE = `
  mutation UpdateUserPreference($input: updateUserPreferenceInput!) {
    me {
      updateUserPreference(input: $input) {
        followOffer {
          followOwnOffer
          followCommentedOffer
        }
      }
    }
  }
`;

export default UPDATE_USER_PREFERENCE;
